import createModule from "../createModule"
import view from "./view"
import { Creators as PortfolioRootCreators } from "modules/portfolio-root/model"
import { Creators as ProfileCreators } from "model/profileModal"
import { getEarliestDate, getLatestDate } from "modules/portfolio-root/selectors/dates"
import { getPeriod, getViewType, getSelectedModelId, getCurrency, getPortfolioFxHedgeEnabled } from "modules/portfolio-root/selectors/portfolios"
import { getBasePositionSet, getBaseSignature } from "selectors/base"
import { getStartDate, getEndDate, getSelectedDate, getFetchStartDate } from "selectors/dates"
import { Creators as notificationsCreators } from "modules/notifications/model"
import { getCategories } from "./selectors/categories"
import { getIdioVsFactors, getRiskTrends, getGmv, getDailyRisk, getGmvTitle, getRiskStartDate, getDatesAdjusted } from "./selectors/trends"
import { VIEW_TYPES } from "helpers/base"
import { MODEL_METADATA_QUERY } from "resources/models"

export default createModule({
  view,
  externalProps: state => ({
    account: state.global.selected.account,
    fxHedgeEnabled: getPortfolioFxHedgeEnabled(state),
    portfolioId: state.global.selected.portfolio,
    modelId: getSelectedModelId(state),
    startDate: getStartDate(state),
    endDate: getEndDate(state),
    date: getSelectedDate(state),
    base: getBasePositionSet(state),
    baseSignature: getBaseSignature(state),
    fetchStartDate: getFetchStartDate(state),
    viewType: getViewType(state),
    currency: getCurrency(state),
  }),
  required: ["account", "portfolioId", "modelId"],
  data: [{
    resource: "overviewRisk",
    as: null,
    url: ({ modelId, portfolioId, endDate, base, baseSignature, fetchStartDate, viewType, currency, fxHedgeEnabled }) => {
      return {
        id: `${modelId}${portfolioId}${fetchStartDate}${endDate}${viewType}${baseSignature}${currency}${fxHedgeEnabled}`,
        query: `query ($modelId: String!, $portfolioId: String!, $from: Date!, $to: Date!, $base: [PositionSetInput]) {
          model (id: $modelId) {
            simulation (positionSet: {
              type: PORTFOLIO,
              id: $portfolioId
            }, from: $from, to: $to, base: $base, interval: AUTO) {
              risk {
                date
                attribution {
                  summary {
                    specific
                  }
                  factors {
                    category
                    id
                    name
                    value
                  }
                }
              }
              composition {
                date
                gmv
                equity:referenceEquity
              }
            }
          }
        }`,
        variables: {
          modelId,
          portfolioId,
          from: fetchStartDate,
          to: endDate,
          base: viewType === VIEW_TYPES.ACTIVE ? [base] : undefined,
        },
      }
    },
  },
  MODEL_METADATA_QUERY,
  ],
  mapStateToProps: state => ({
    earliestDate: getEarliestDate(state),
    latestDate: getLatestDate(state),
    period: getPeriod(state),
    firstDate: getRiskStartDate(state),
    riskTrends: getRiskTrends(state),
    idioVsFactors: getIdioVsFactors(state),
    gmv: getGmv(state),
    gmvTitle: getGmvTitle(state),
    dailyRisk: getDailyRisk(state),
    categories: getCategories(state),
    datesAdjusted: getDatesAdjusted(state),
    currency: getCurrency(state),
  }),
  actions: {
    openFactorProfile: ProfileCreators.openFactorProfile,
    setDate: PortfolioRootCreators.setDate,
    resetDate: PortfolioRootCreators.resetDate,
    setPeriod: PortfolioRootCreators.setPeriod,
    addNotification: notificationsCreators.add,
  },
})
